import React, {Fragment} from "react";
import ReactHtmlParser from "react-html-parser";
import AudioPlayer from "react-h5-audio-player";
import 'react-h5-audio-player/lib/styles.css';
import {LANGUAGES} from "../constants";
import {Button} from "react-bootstrap";
import {Translation} from "react-i18next";

class DefElement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
           name: this.props.name,
            file: this.props.file,
        };
    }


    render() {
       // console.log(this.props.elementData);
        return (
            <Fragment>
                <div id="block">
                    <div className="container-fluid content" id="tablo">
                        <h4 className="title">{this.props.name}</h4>

                            <AudioPlayer
                                //autoPlay
                                src={this}
                                onPlay={e => console.log("onPlay")}
                                className="player"
                                //loop={true}
                                // other props here
                            />
                        {(this.props.elementData.img)
                            ? <p id="img_i"><img src={'https://static.roomab.art/'+this.props.elementData.img} alt=''/></p> : ''}
                    </div>
                </div>
            </Fragment>
        );
    }
}


export default DefElement;